import { initUserVaccount } from "../../user-vaccounts";

/** @typedef {import("../../user-vaccounts").UserVaccount} NshopOrder_Vaccount */
/** @typedef {import("./nshop-orders.const").NshopOrder_State} NshopOrder_State */
/** @typedef {import("./nshop-orders.const").NshopOrder_Payment_Method} NshopOrder_Payment_Method */

/**
 * @typedef {object} NshopOrder
 *
 * @property {string} _id
 *
 * @property {string} _member
 * @property {string} _payment
 * @property {string} _vaccount
 *
 * @property {string} orderNo
 * @property {string} orderName
 *
 * @property {number} count
 *
 * @property {object} price
 * @property {number} price.unit
 * @property {number} price.sum
 * @property {number} price.fee
 * @property {number} price.sale
 *
 * @property {object} payment
 * @property {NshopOrder_Payment_Method} payment.method
 * @property {NshopOrder_Vaccount} [payment.vaccount]
 *
 * @property {object} message
 * @property {number} message.count
 *
 * @property {NshopOrder_Pin[]} pins
 *
 * @property {NshopOrder_State} state
 *
 * @property {boolean} [gainable]
 *
 * @property {Date|string|number} [createdAt]
 * @property {Date|string|number} [updatedAt]
 * @property {Date|string|number} [paymentAt]
 * @property {Date|string|number} [stoppedAt]
 * @property {Date|string|number} [canceledAt]
 */

/**
 * @param {Partial<NshopOrder>} data
 * @returns {NshopOrder}
 */
export function initNshopOrder(data) {
    data = {
        ...(data || {}),

        _id: data?._id,

        _member: data?._member || null,
        _payment: data?._payment || null,
        _vaccount: data?._vaccount || null,

        orderNo: data?.orderNo || null,
        orderName: data?.orderName || null,

        count: data?.count || 0,

        price: {
            ...(data?.price || {}),

            unit: data?.price?.unit || 0,
            sum: data?.price?.sum || 0,
            fee: data?.price?.fee || 0,
            sale: data?.price?.sale || 0,
        },

        message: {
            ...(data?.message || {}),

            count: data?.message?.count || 0,
        },

        payment: {
            ...(data?.payment || {}),

            method: data?.payment?.method || null,
            vaccount: data?.payment?.vaccount || null,
        },

        pins: [...(data?.pins || [])].map(initNshopOrder_Pin),

        state: data?.state || null,

        gainable: data?.gainable ?? false,

        createdAt: data?.createdAt,
        updatedAt: data?.updatedAt,
        paymentAt: data?.paymentAt,
        stoppedAt: data?.stoppedAt,
        canceledAt: data?.canceledAt,
    };

    if (!data._id) delete data._id;
    if (!data.state) delete data.state;
    if (!data.createdAt) delete data.createdAt;
    if (!data.updatedAt) delete data.updatedAt;
    if (!data.paymentAt) delete data.paymentAt;
    if (!data.stoppedAt) delete data.stoppedAt;
    if (!data.canceledAt) delete data.canceledAt;

    if (data.payment.vaccount) data.payment.vaccount = initUserVaccount(data.payment.vaccount);
    else delete data.payment.vaccount;

    return data;
}

/**
 * @typedef {object} NshopOrder_Pin
 *
 * @property {string} pno
 * @property {string} lv
 * @property {number} faceamt
 * @property {boolean} isGained
 * @property {string} issuedAt
 * @property {string} expiredAt
 */

/**
 * @param {Partial<NshopOrder_Pin>} data
 * @returns {NshopOrder_Pin}
 */
export function initNshopOrder_Pin(data) {
    data = {
        ...(data || {}),

        pno: data?.pno || null,
        lv: data?.lv || null,
        faceamt: data?.faceamt || null,
        isGained: data?.isGained ?? false,
        issuedAt: data?.issuedAt || null,
        expiredAt: data?.expiredAt || null,
    };

    return data;
}
